export default "__VITE_ASSET__hFqjiD$D__"